import React, { useState, useMemo, useCallback } from "react"
import PropTypes from "prop-types"

import { Modal, Stack } from "@components/Page"
import { DRAWER_WIDTH3 } from "@components"
import { useAppContext } from "@components/AppContext"

import listProjectFiles from "./helpers/listProjectFiles"
import TargetProjectSelect from "./TargetProjectSelect"
import { InvestmentShape } from "../shapes"
import listProjectTransactions from "./helpers/listProjectTransactions"
import InvestmentsTransferTable from "./InvestmentsTransferTable"

const LABEL_TITLE = "Transfer Investments"


const InvestmentsTransferModal = ({ modal, projectId, investments }) => {
  const [ investmentIds, setInvestmentIds ] = useState([])

  const [ sourceFiles, setSourceFiles ] = useState([])
  const [ sourceBatches, setSourceBatches ] = useState([])
  const [ sourceTransactions, setSourceTransactions ] = useState([])

  const [ targetProjectId, setTargetProjectId ] = useState()
  const [ targetFiles, setTargetFiles ] = useState([])
  const [ targetBatches, setTargetBatches ] = useState([])
  const [ targetInvestments, setTargetInvestments ] = useState([])
  const [ targetTransactions  , setTargetTransactions ] = useState([])

  const { request } = useAppContext()

  const sourceInvestments = useMemo(() =>
    investments.filter(({ id }) => investmentIds.includes(id))
  , [ investments, investmentIds ])

  const getSourceBatchName = useCallback((id) =>
    sourceBatches.find(batch => batch.id === id)?.name
  , [ sourceBatches ])

  const getTargetBatchName = useCallback((id) =>
    targetBatches.find(batch => batch.id === id)?.name
  , [ targetBatches ])

  modal.current.open = async (sourceInvestmentIds, afterAction) => {
    setInvestmentIds(sourceInvestmentIds)

    const todo1 = 'TODO: Some batches might have to be created, and files are ' +
      'migrated into these new batches: batchId, projectId'

    const [ batches, files ] = await listProjectFiles(request, projectId)
    setSourceFiles(files)
    setSourceBatches(batches)

    console.info(todo1, files)

    const todo2 = 'TODO: Migrate related investments transactions: projectId.'

    const transactions = await listProjectTransactions(request, projectId)
    setSourceTransactions(transactions)

    console.info(todo2, transactions)
  }

  const onClose = () => {
    setSourceFiles([])
    setInvestmentIds([])
    setTargetProjectId()
    setSourceTransactions([])
    setSourceBatches([])
    setTargetProjectId()
    setTargetFiles([])
    setTargetBatches([])
    setTargetInvestments([])
    setTargetTransactions([])
  }

  const isOpen = investmentIds.length > 0;

  const modalProps = {
    title: LABEL_TITLE,
    width: DRAWER_WIDTH3,
    isOpen,
    onClose,
  }

  const transferTableProps = {
    sourceProjectId: projectId,
    getSourceBatchName,
    sourceFiles,
    sourceInvestments,
    sourceTransactions,
    getTargetBatchName,
    targetFiles,
    targetInvestments,
    targetTransactions,
  }

  return (
    <Modal {...modalProps}>
      <Stack>
        <TargetProjectSelect
          targetProjectId={targetProjectId}
          setTargetProjectId={setTargetProjectId}
          setTargetFiles={setTargetFiles}
          setTargetBatches={setTargetBatches}
          setTargetInvestments={setTargetInvestments}
          setTargetTransactions={setTargetTransactions}
        />

        <InvestmentsTransferTable
          {...transferTableProps}
        />
      </Stack>
    </Modal>
  )
}

InvestmentsTransferModal.propTypes = {
  modal: PropTypes.shape().isRequired,
  projectId: PropTypes.string.isRequired,
  investments: PropTypes.arrayOf(InvestmentShape).isRequired,
}

export default InvestmentsTransferModal;
